"use client";

import { eventNames, PXEventPayload } from "@/constants/events";
import mixpanel from "mixpanel-browser";

export default function trackPxEvent(payload: PXEventPayload) {
  if (process.env.NEXT_PUBLIC_ENV === "development") {
    return;
  }
  if (mixpanel.has_opted_out_tracking()) {
    return;
  }
  mixpanel.track(eventNames[payload.event], payload);
}
